export default {
    ESC: 27,
    ENTER: 13
};
